import React, { useEffect, useState } from "react";
import { Pagination, PaginationItem, PaginationLink, Badge } from "reactstrap";

import { Table } from "reactstrap";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import WithdrawModel from '../Profile/Assets-List/withdraw-model';
import DepositModel from '../Profile/Assets-List/deposit-model';
import { transactionHistory, getProfile, getSettings, addFavourite } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import useToastr from "helpers/toastr";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import ButtonLoader from "Component/Common/ButtonLoader";
import { useTranslation } from 'react-i18next';

const Portfolio = () => {
  const itemsPerPage = 1;
  const navigate = useNavigate();
  const toastr = useToastr();

  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setshowModal] = useState(false);
  const [isDeposit, setIseDeposit] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [selectedAsset, setSelectedAsset] = useState();
  const { t } = useTranslation();

  const { listing, total, loading } = useSelector(({ Register }) => Register);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state?.Login);

  const [filter, setFilter] = useState({
    orderBy: "createdAt",
    order: -1,
    page: 1,
    pageSize: 10,
    id: user?._id,
  });

  const [portfolioList, setPortfolioList] = useState([]);
  const { settingInfo, settingsLoading } = useSelector(({ Settings }) => Settings);
  const { favLoading } = useSelector(({ Favourite }) => Favourite);


  useEffect(() => {
    dispatch(getSettings());

  }, [])

  /**
     * Used for calling the api of latest crypto's price
     */

  const getUserProfile = () => {
    const callBack = (response) => {
      if (response.status == "success") {
        if (response.data?.vault?.assets.length > 0) {
          setPortfolioList(response.data?.vault?.assets);

        }

      }
    }
    dispatch(getProfile({ id: user?._id }, callBack))

  }
  useEffect(() => {
    getUserProfile()
  }, [])


  const indexOfLastItem = currentPage * itemsPerPage;

  const handleBack = () => {
    navigate(-1);
  };


  const handlWithdraw = (obj) => {
    setSelectedAsset(obj)
    setshowModal(true);

  }

  const handlDeposit = (obj) => {
    setSelectedAsset(obj)
    setIseDeposit(true);

  }


  let filteredPlatform = [];
  if (settingInfo?.marqueeData?.length > 0) {
    filteredPlatform = portfolioList.map((obj) => {
      const mergeArr = settingInfo?.marqueeData.find(item1 => item1.mainnet_symbol === obj.mainnet_symbol);
      if (mergeArr) {
        return { ...obj, ...mergeArr }
      }
      return null
    })
  }

  const handleSymbol = (e, item) => {
    e.preventDefault();
    navigate("/graph/" + item?.mainnet_symbol, {
      state: item
    })

  }

  const handeFav = (e, item) => {
    e.preventDefault();

    const callback = (response) => {
      if (response.status == "success") {
        getUserProfile();
        toastr.success(response?.message)
      }
    }

    dispatch(addFavourite({
      "isFavorite": !item?.isFavorite,
      "tokenId": item?.crypto
    }, callback))

  }

  /**
     * Used for render the UI for portfolio
     */
  return (
    <React.Fragment>

      <section className="history_page home_banner_main portfolio_table position-relative">

        <WithdrawModel
          show={showModal}
          onHide={() => setshowModal(!showModal)}
          selectedAsset={selectedAsset}
        />


        <DepositModel
          show={isDeposit}
          onHide={() => setIseDeposit(!isDeposit)}
          selectedAsset={selectedAsset}
        />

        <div className="top_circle"></div>
        <Container>
          <div className="d-flex align-items-center">
            <Link to="" onClick={handleBack} className="arrow_back me-3">
              <svg
                role="button"
                width="25"
                height="25"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="#000"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1"
                  d="M13 5H1m0 0 4 4M1 5l4-4"
                />
              </svg>
            </Link>

            <h4 className="text-start m-0">{t('portfolio')}</h4>
          </div>

          <div className="history_table mt-4">
            {loading || settingsLoading && <ButtonLoader />}
            <div className="table-responsive">
              {(
                <table className="table table-nowrap">
                  <thead>
                    <th>{t('asset')}</th>

                    <th>{t('price')}</th>

                    <th>{t('holdings')}</th>

                    <th>{t('actions')}</th>
                  </thead>
                  <tbody>
                    {filteredPlatform.length > 0 &&
                      filteredPlatform.map((item, idx) => (
                        <tr key={idx}>
                          <td  >
                            <div className="asetscell d-flex align-items-cnenter gap-3">
                              <div className="icon_img">
                                <img src={item?.icon} alt="" className="img-fluid" />
                              </div>
                              <p onClick={(e) => handleSymbol(e, item)}>
                                {item?.name + " (" + item.mainnet_symbol + ")"}
                              </p>
                              <OverlayTrigger
                                key={"top"}
                                placement={"top"}
                                overlay={
                                  <Tooltip >
                                    {item?.isFavorite ? t('add_to_favourites') : t('remove_to_favourites')}
                                  </Tooltip>
                                }
                              >
                                <Button onClick={(e) => handeFav(e, item)} variant="transparent" className="border-0 p-0">
                                  {
                                    item?.isFavorite ?
                                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 12.27 18.6 15.36 13.45 20.03L12 21.35Z" fill="#d92127" />
                                      </svg> :


                                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12.1 18.55L12 18.65L11.89 18.55C7.14 14.24 4 11.39 4 8.5C4 6.5 5.5 5 7.5 5C9.04 5 10.54 6 11.07 7.36H12.93C13.46 6 14.96 5 16.5 5C18.5 5 20 6.5 20 8.5C20 11.39 16.86 14.24 12.1 18.55ZM16.5 3C14.76 3 13.09 3.81 12 5.08C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.41 2 8.5C2 12.27 5.4 15.36 10.55 20.03L12 21.35L13.45 20.03C18.6 15.36 22 12.27 22 8.5C22 5.41 19.58 3 16.5 3Z" fill="#4A4A4A" />
                                      </svg>
                                  }
                                </Button>
                              </OverlayTrigger>
                            </div>
                          </td>
                          <td>${item.usdValue}
                            <p
                              className={`m-0 mx-1 ${item.isInPlus ? "text-success" : "text-danger"
                                } `}
                            >
                              ${Math.abs(item.deferenceInPrice?.toFixed(2))}
                              {item.isInPlus ? (
                                <span className="ms-1">
                                  +
                                </span>
                              ) : (
                                <span className="ms-1">
                                  -
                                </span>
                              )}
                            </p>
                          </td>

                          <td>{"$" + item?.available + " " + item.mainnet_symbol}</td>
                          <td>

                            <div className="d-flex align-items-center gap-3 justify-content-center">
                              <Button onClick={() => handlWithdraw(item)} className="btn_widthdraw copy_btn">
                                <span className="text-capitalize his-confirmed">{t('withdraw')}</span>

                              </Button>

                              <Button onClick={() => handlDeposit(item)} className="btn_widthdraw copy_btn">
                                <span className="text-capitalize his-confirmed">{t('deposit')}</span>

                              </Button>
                            </div>

                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}
              {/* {!loading && portfolioList.length > 0 && (
                <div className="d-flex align-items-center justify-content-end mt-5 me-3">
                  <Pagination aria-label="Page navigation example">
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink
                        previous
                        onClick={() => handleClick(currentPage - 1)}
                      />
                    </PaginationItem>

                    {renderPagination()}

                    <PaginationItem disabled={currentPage === totalPages}>
                      <PaginationLink
                        next
                        onClick={() => handleClick(currentPage + 1)}
                      />
                    </PaginationItem>
                  </Pagination>
                </div>
              )} */}
              {!loading && portfolioList.length === 0 && (
                <p>{t('no_items_yet')}</p>
              )}
            </div>
          </div>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Portfolio;
